// extracted by mini-css-extract-plugin
export default {"container":"TimeClock_container__hj04Q","value":"TimeClock_value__5kDWd","delimiter":"TimeClock_delimiter__q7xbz","blink":"TimeClock_blink__sMyka"};